import { z } from 'zod';

// Schema for FormDialog - matches only actual form fields
export const formSchema = z.object({
  ma_ngv: z.string().optional().nullable(),
  ma_so_thue: z.string().optional().nullable(),
  ong_ba: z.string().optional().nullable(),
  e_mail: z.string().optional().nullable(),
  dien_giai: z.string().optional().nullable(),
  ma_httt: z.string().optional().nullable(),
  pt_tao_yn: z.boolean().optional().nullable(),
  transfer_yn: z.boolean().optional().nullable(),
  invat_yn: z.boolean().optional().nullable(),
  ten_vt_thue: z.string().optional().nullable(),
  so_ct0: z.string().optional().nullable(),
  so_ct2: z.string().optional().nullable(),
  so_ct3: z.string().optional().nullable(),
  ngay_ct0: z.string().optional().nullable(),
  ngay_lct: z.string().optional().nullable(),

  // BasicInfoTab - Document Information
  ngay_ct: z.string().optional().nullable(),
  ma_nt: z.string().optional().nullable(),
  status: z.string().optional().nullable(),
  ma_mau_bc: z.string().optional().nullable(),
  ma_tc_thue: z.string().optional().nullable(),

  // OtherTab Fields (all text fields)
  ly_do_huy: z.string().optional().nullable(),
  ly_do: z.string().optional().nullable(),
  ghi_chu: z.string().optional().nullable(),

  // EInvoiceTab Fields (text and date fields)
  so_ct_hddt: z.string().optional().nullable(),
  ngay_ct_hddt: z.string().nullable(), // date field
  so_ct2_hddt: z.string().optional().nullable(),
  ma_mau_ct_hddt: z.string().optional().nullable(),
  ma_tt: z.string().optional().nullable(),
  ma_tthddt: z.string().optional().nullable(),
  ma_pttt: z.string().nullable()
});

export const initialFormValues: FormValues = {
  ma_ngv: '1',
  ma_so_thue: '',
  ong_ba: '',
  e_mail: '',
  dien_giai: '',
  ma_httt: 'TMB',
  pt_tao_yn: false,
  transfer_yn: true,
  invat_yn: false,
  ma_mau_bc: '3',
  ma_tc_thue: '1',
  so_ct0: '',
  so_ct2: '',
  so_ct3: '',
  ngay_ct0: new Date().toISOString().split('T')[0],

  // BasicInfoTab - Document Information
  ngay_ct: new Date().toISOString().split('T')[0],
  ngay_lct: new Date().toISOString().split('T')[0],
  ma_nt: '',
  status: '5',

  // OtherTab Fields (all text fields)
  ly_do_huy: '',
  ly_do: '',
  ten_vt_thue: '',
  ghi_chu: '',

  // EInvoiceTab Fields (text and date fields)
  so_ct_hddt: '',
  ngay_ct_hddt: '',
  so_ct2_hddt: '',
  ma_mau_ct_hddt: '',
  ma_tt: '',
  ma_tthddt: '0',
  ma_pttt: ''
};

export type FormValues = z.infer<typeof formSchema>;

// Schema for SearchDialog
export const searchSchema = z.object({
  startDate: z.string().optional().nullable(),
  endDate: z.string().optional().nullable(),
  voucherNumberStart: z.string().optional().nullable(),
  voucherNumberEnd: z.string().optional().nullable(),
  debitAccount: z.string().optional().nullable(),
  customerCode: z.string().optional().nullable(),
  employeeCode: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  unit: z.string().optional().nullable(),
  status: z.string().optional().nullable(),
  filterByUser: z.string().optional().nullable(),
  revenueAccount: z.string().optional().nullable()
});

export type SearchFormValues = z.infer<typeof searchSchema>;
